import styled from "@emotion/styled";
import { Snackbar } from "@mui/material";

export enum AlertType {
  Success = "success",
  Error = "error",
}

export const StyledSnackbar = styled(Snackbar)<{ type: AlertType }>`
  width: 360px;
  padding: 0.5rem 0.75rem;
  border-radius: 0.75rem;
  background-color: ${({ type }) =>
    type === AlertType.Success ? "#E0FAEC" : "rgba(255, 255, 255, 0.90)"};

  box-shadow:
    0px 4px 8px -2px rgba(16, 24, 40, 0.1),
    0px 2px 4px -2px rgba(16, 24, 40, 0.06);

  & .MuiPaper-root {
    padding: 0;
    background-color: ${({ type }) =>
      type === AlertType.Success ? "#E0FAEC" : "rgba(255, 255, 255, 0.90)"};
    gap: 0.75rem;
  }

  & .MuiAlert-action {
    margin-right: 0;
    padding: 0;
  }

  & .MuiAlert-message {
    padding: 0;
  }

  & .MuiAlert-icon {
    margin-right: 0;
    padding: 0;
  }
`;
